<template>
  <div :class="'head-wrap' + (displayShadow ? ' box-shadow' : '')">
    <div class="navigation">
      <img :src="_IsDevMode?'/images/public/guide_logo_1.png':'/images/public/guide_logo.png'" @click="$router.push('/index_page')">
      <ul  class="menu-wrap">
        <li class="mr-3" :class="{'active':activeKey=='1'}" @click="$router.push('/index_page')">首页</li>
        <li class="mr-3" :class="{'active':activeKey=='2'}" @click="$router.push('/index_hotel')">找酒店</li>
        <li class="mr-3" :class="{'active':activeKey=='7'}"  @click="$router.push('/about_us')">关于我们</li>
      </ul>
      <el-menu :default-active="activeKey"       
              mode="horizontal"
              @select="handleSelect"
              text-color="#333"
              >
        <!-- <el-menu-item index="1" class="mr-3" @click="$router.push('/index_page')">首页</el-menu-item>
        <el-menu-item index="2" class="mr-3" @click="$router.push('')">找酒店</el-menu-item>
        <el-menu-item index="3" class="mr-3" @click="$router.push('/index_homestay')">民宿</el-menu-item>
        <el-menu-item index="4" class="mr-3" @click="$router.push('/index_scenic')">景区</el-menu-item>
        <el-menu-item index="5" class="mr-3" @click="$router.push('/index_hotel_activity')">酒店活动</el-menu-item>
        <el-menu-item index="5" class="mr-3" @click="$router.push('/index_product')">度假产品</el-menu-item>
        <el-menu-item index="6" class="mr-3" @click="$router.push('/index_brand')">半山伴水品牌馆</el-menu-item>
        <el-menu-item index="7" class="mr-3" @click="$router.push('/about_us')">关于我们</el-menu-item> -->
      </el-menu>
      <!--右侧会员中心-->
      <div class="d-center-between h6 member-wrap" v-if="!userLoginMessage.id&&!userLoginMessage.uid">
        <div class="login" @click="$router.push({name:'userLogin'})" >
          <i class="iconfont  icon-yonghudenglu"></i>登录
        </div>
        <div class="register" @click="$router.push({name:'identity'})" ><i class="el-icon-user"></i>注册</div>
        <!-- <a href="javascript:;" class="login" >登录/注册</a> -->
      </div>
      <div class="d-center-between h6 member-wrap individual " v-else  @mouseenter="dropDownMenuShow=true" @mouseleave="dropDownMenuShow=false">
          <div class="individual-name">
              <span>欢迎您,{{userLoginMessage.name?userLoginMessage.name:userLoginMessage.truename}}</span>
              <i class="el-icon-arrow-down"></i>
              <!-- 下拉菜单 -->
              <div  class="dropDownMenu" v-if="dropDownMenuShow">
                <div class="dropDownMenu-arrow"></div>
                <ul class="dropDownMenu-list">
                  <li v-if="userLoginMessage.status == 2&&userLoginMessage.type == 3" @click="$router.push({name:'regBasicClose'})"><i class="iconfont  icon-ruzhugongsi"></i>关联酒店</li>
                  <li v-if="userLoginMessage.status == 1||isAdmin" @click="$router.push({name:'CenterIndex'})"><i class="iconfont  icon-geren"></i>个人中心</li>
                  <li v-if="userLoginMessage.status == 1||isAdmin" @click="$router.push({name:'OrderLists'})"><i class="iconfont  icon-ruzhu"></i>订单管理</li>
                  <li @click="logout" ><i class="iconfont  icon-tuichu"></i>退出登录</li>
                </ul>
              </div>
          </div>
      </div>
    </div>
  </div>
</template>

<script>
  import {mapState, mapActions,mapGetters} from 'vuex'

  export default {
    name: 'NavHeader',
    data () {
      return {
        activeKey: '1',                                //选中tab选项卡
        timer: null,
        displayImg: false,                            //是否显示logo
        displayMode: false,                           //是否显示阴影
        displayShadow: false,                         //导航样式
        scrollTop: 0, // 滚动条距离顶部的距离
        dropDownMenuShow: false,                        //下拉菜单显示状态                        
      }
    },
    computed: {
      ...mapState(['userLoginMessage','userHeadInfo']),
      ...mapGetters(['isAdmin']),
    },
    mounted() {
      // 挂载时监听滚动事件
      window.addEventListener("scroll", this.handleScroll);
    },
      beforeDestroy() {
      // 销毁时移除监听（防止内存泄漏）
      window.removeEventListener("scroll", this.handleScroll);
    },
    watch: {
      $route: {
        handler (val) {
          let routeTo = val.path.split('/')[1]
          switch (routeTo) {
            case 'index_page':
              this.activeKey = '1'
              break
            case 'index_hotel':
              this.activeKey = '2'
              break
            case 'index_homestay':
              this.activeKey = '3'
              break
            case 'index_scenic':
              this.activeKey = '4'
              break
            case 'index_product':
              this.activeKey = '5'
              break
            case 'index_brand':
              this.activeKey = '6'
              break
            case 'about_us':
              this.activeKey = '7'
              break
          }
          this.displayMode = typeof val.path.split('/')[3] !== 'undefined'
        },
        immediate: true
      },
    },
    methods: {
      ...mapActions(['logout']),
      handleSelect (key) {
        this.activeKey = key
      },
      handleScroll() {
        // 获取滚动条距离顶部的距离（兼容所有浏览器）
        this.scrollTop =
          window.pageYOffset ||
          document.documentElement.scrollTop ||
          document.body.scrollTop;

        if (this.scrollTop === 0) {
          this.displayShadow = false
        } else if (this.scrollTop > 100) {
          this.displayShadow = true
        }
      },
    }
  }
</script>

<style lang="scss" scoped>
  .menu-wrap{
      height: 60px;
      display: flex;
    overflow: hidden;
  }
  .menu-wrap li{
    height: 40px;
    line-height: 40px;
    width: 100px;
    color: #333;
    border-radius: 50px;
    margin-top: 10px;
    cursor: pointer;
  }
  .menu-wrap .active{
    box-shadow: 0px 6px 6px #97d4ff ;
    background-color: var(--smtc-color-primary);
    color: #fff;
  }
  .head-wrap {
    //position: relative;
    position: -webkit-sticky;
    position: sticky;
    z-index: 999;
    top: 0;
    left: 0;
    height: 80px;
    width: 100%;
    display: flex;
    margin: 0 auto;
    align-items: center;
    justify-content: space-around;
    background-color: #fff;
    --tw-shadow: 0 15px 15px -12px var(--tw-shadow-color, rgb(0 0 0 / 0.1));
    box-shadow:  var(--tw-shadow);
    img {
      width: 180px;
      height: 61px;
      margin-right: 60px;
    }
    .member-wrap {
      // max-width: 255px;
      margin-left: auto;
      span{
        vertical-align: middle
      }
      label{
        display: -webkit-box;
        vertical-align: middle;
        max-width: 85px!important;
        max-height: 60px;
        overflow: hidden;
        text-align: left;
        -webkit-line-clamp:1;
        -webkit-box-orient: vertical;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis
      }
    }
  }

  .box-shadow {
    background-color: #fff;
    box-shadow: 0 2px 9px lightgrey;
  }

  .el-menu.el-menu--horizontal {
    border-bottom: none;
    :hover {
      color: #fff !important;
      font-weight: bold !important;
      background-color: transparent !important;
    }
  }

  .el-menu-item {
    line-height: 80px;
    height: 80px;
    font-size: 16px;
  }

  .el-menu-item.is-active {
    // background-color: rgb(18, 178, 203) !important;
    // border-bottom-color: rgb(18, 178, 203) !important;
    font-weight: bold;  
    height: 80px;
  }
  .navigation{
    width: 1200px;
    min-width: 1200px;
    margin: 0 auto;
    display: flex;
  }
  .login{
    padding: 8px 12px;
    border-radius: 8px;
    border: 1px var(--smtc-color-primary) solid;
    background-color: var(--smtc-color-primary);
    color: #fff;
    box-shadow: 0 2px 4px #eee;
    cursor: pointer;
    i{
      margin-right: 6px;
      font-size: 14px;
    }
  }
  .login:hover{
    background-color: var(--smtc-color-primary-hover);
  }
  .register{
    padding: 8px 12px;
    border-radius: 8px;
    margin-left: 10px;
    cursor: pointer;
    i{
      margin-right: 6px;
      font-size: 14px;
    }
  }
  .box-shadow .el-menu-item.is-active{
    color: var(--smtc-color-primary) !important;
  }
  .cloes,.cloes a{
    color: #fff;
  }
  .text-white span,.text-white a{
    color: #333;
  }
  .individual{
    display: flex;
    justify-content: center;
    flex-direction: column;
  }
  .individual-name{
    background-color: var(--smtc-color-TextBackground-grayBlue);
    height: 36px;
    line-height: 36px;
    font-size: 12px;
    padding: 0 10px;
    border-radius: 50px;
    position: relative;
    z-index: 10;
    cursor: pointer;
    &:hover span{
      color: var(--smtc-color-primary);
    }
    >i{
      margin-left: 4px;
      transition: transform 0.3s ease; /* 平滑旋转 */
    }
    &:hover>i{
      transform: rotate(180deg);
    }
  }
  .dropDownMenu{
    position: absolute;
    top: 46px;
    left: calc(50% - 55px);
    background-color: #fff;
    border-radius: 6px;
    box-shadow: 0px 1px 6px #ccc;
    width: 110px;
    z-index: 10;
  }
  .dropDownMenu-arrow{
    position: absolute;
    top: -8px;
    left: calc(50% - 10px);
    border-width: 0 8px 8px;
    border-style: solid;
    width: 0;
    height: 0;
    border-style: solid;
    border-color: rgba(0,0,0,0) rgba(0,0,0,0) #eee;
  }
  .dropDownMenu-arrow:after {
    content: "";
    position: absolute;
    top: 1px;
    left: -7px;
    border-width: 0 7px 7px;
    border-style: solid;
    border-color: rgba(0,0,0,0) rgba(0,0,0,0) #fff
  }
  .dropDownMenu-list li{
      padding: 0 6px;
      width: 80%;
      margin: 8px auto;
      cursor: pointer;
      border-radius: 50px;
      line-height: 30px;
    i{
      font-size: 14px;
      color: #666;
      margin-right: 6px;
    }
    &:hover{
      background-color: var(--smtc-color-TextBackground-grayBlue);
      color: var(--smtc-color-primary);
      i{
        color: var(--smtc-color-primary);
      }
    }
  }
</style>
